import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../common-data/Converts";
import PaginationBar from "../lms-customised-comps/PaginationBar";
import Loader from "../../../ui/Loader";
import {
  ClockIcon,
  CallIcon,
  CalenderIcon,
  HourglassIcon,
  XCircleIcon,
  CheckIcon,
} from "../../../../images/icons/icons";

const LMSTodaysFollowups = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  isMissed,
  setSelectedRow,
  selectedRow,
  onCardClick,
  setModValues,
}) => {
  const { allLeads, allLeadsLoading, allLeadsError } = useSelector(
    (state) => state.api
  );

  const iniLeadsDatas = {
    data: [],
    pagination: [],
  };
  const [leadsDatas, setLeadsDatas] = useState(iniLeadsDatas);

  useEffect(() => {
    if (
      !allLeadsLoading &&
      !allLeadsError &&
      allLeads?.status &&
      allLeads?.data
    ) {
      setLeadsDatas((prev) => ({
        ...prev,
        data: allLeads.data,
        pagination: allLeads?.pagination,
      }));
    } else {
      setLeadsDatas(iniLeadsDatas);
    }
  }, [allLeadsLoading, allLeadsError, allLeads]);

  return (
    <div className="followups-schedule-card-v2">
      <div className="followups-schedule-title-v2">
        {isMissed ? "Missed Follow-ups" : "Today's Follow-up Schedule"}{" "}
        <span className="badge-count">
          {leadsDatas.pagination?.[0]?.pagination}
        </span>
      </div>

      <div className="followups-schedule-list-v2">
        {allLeadsLoading ? (
          <Loader />
        ) : leadsDatas.data?.length > 0 ? (
          leadsDatas.data.map((item, idx) => {
            const leadStatus = item.lead_status;

            const leadStatusIcon = (leadStatus) => {
              if (leadStatus === "converted") {
                return <CheckIcon />;
              } else if (leadStatus === "pending") {
                return <HourglassIcon />;
              } else {
                return <XCircleIcon />;
              }
            };

            return (
              <div
                key={item.lead_id || idx}
                className={`followups-schedule-item-v2 ${
                  selectedRow && selectedRow.lead_id === item.lead_id
                    ? "active"
                    : ""
                }`}
                // onClick={() =>
                //   selectedRow && selectedRow.lead_id === item.lead_id
                //     ? setSelectedRow(null)
                //     : isMissed
                //     ? setSelectedRow(item)
                //     : null
                // }
                // style={{ cursor: isMissed ? "pointer" : "not-allowed" }}
              >
                <div className="followups-schedule-info-v2">
                  <div className="followups-info-row">
                    <span className="followups-schedule-icon orange">
                      {leadStatusIcon(leadStatus)}
                    </span>
                    <span className="followups-customer-name bold">
                      {item.name}
                    </span>
                  </div>
                  <div className="followups-info-row">
                    <span className="followups-schedule-icon phone">
                      <CallIcon />
                    </span>
                    <span className="followups-customer-phone">
                      {item.mobile}
                    </span>
                  </div>
                  <div className="followups-info-row">
                    <span className="followups-schedule-icon orange">
                      <ClockIcon color="#ea580c" />
                    </span>
                    <span className="followups-schedule-time-v2 orange">
                      {formatDateTime(item?.next_followup_date)} - Call
                    </span>
                  </div>
                  <a href="#" className="followups-customer-gym gym-link">
                    {item.gym_name}
                  </a>
                  {item.mem_lead_stage && (
                    <span className="followups-mem-lead-stage-highlight">
                      {item.mem_lead_stage}
                    </span>
                  )}
                </div>
                <div className="followups-schedule-center-v2">
                  <div className="followups-fd-label">
                    FD: {item.agent_name || "Priya Singh"}
                  </div>

                  <div className="followups-amount">₹{item.amount || 0}</div>

                  <div className="followups-amount-desc">
                    {item?.followup_details?.[1]?.remarks || "-"}
                  </div>

                  <button
                    className="followups-fd-btn"
                    onClick={() =>
                      setModValues({
                        isModOpen: true,
                        modName: "view",
                        rowData: item,
                      })
                    }
                  >
                    View Details
                  </button>
                </div>
                <div className="followups-schedule-actions-v2">
                  <button
                    className={`followups-action-btn ${
                      leadStatus === "converted"
                        ? "complete"
                        : leadStatus === "pending"
                        ? "pending"
                        : "missed"
                    }`}
                  >
                    {leadStatusIcon(leadStatus)}
                    {leadStatus?.replace(/_/g, " ")}
                  </button>

                  {leadStatus !== "converted" && (
                    <button
                      className="followups-action-btn reschedule-btn"
                      onClick={() =>
                        selectedRow && selectedRow.lead_id === item.lead_id
                          ? setSelectedRow(null)
                          : setSelectedRow(item)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <CalenderIcon />
                      Reschedule
                    </button>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <span className="followups-customer-name">No follow-ups today.</span>
        )}
      </div>

      {Array.isArray(leadsDatas.pagination) &&
        leadsDatas.pagination.length > 0 &&
        Number(leadsDatas.pagination[0]?.pagination) > 5 && (
          <PaginationBar
            isPage={isPage}
            setIsPage={setIsPage}
            paginationArray={leadsDatas.pagination}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
    </div>
  );
};

export default LMSTodaysFollowups;
